import React, { useState } from "react";
import { Tooltip } from "@mui/material";
import composedIncidentLogsContainer from "../../../containers/IncidentLogsContainer";
import IncidentLogsList from "./IncidentLogsList";
import IncidentLogsListMobile from "./IncidentLogsListMobile";

const IncidentLogMainComponent = ({ deviceInfo, ...props }) => {
  const [viewToolTip, setViewToolTip] = useState(false);

  const printContent = () => {
    if (deviceInfo == "Mobile") {
      return <IncidentLogsListMobile />;
    } else {
      return <IncidentLogsList />;
    }
  };

  return (
    <React.Fragment>
      <div className="job-bx submit-resume" id="scrollFocusElement">
        <div className="job-bx-title clearfix">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 mb-2">
                <h5 className="font-weight-700 pull-left text-uppercase">
                  Incident Logs
                </h5>
                <div className="col-sm-12">
                  {deviceInfo && deviceInfo == "Mobile" ? (
                    <Tooltip
                      title="Create Incident Log"
                      className="text-sm"
                      open={viewToolTip}
                      placement="top"
                    >
                      <a
                        href={"/create-incident-log"}
                        className="pull-right btn btn-success"
                        onTouchStart={(e) => {
                          setViewToolTip(true);
                        }}
                        onTouchEnd={(e) => {
                          setViewToolTip(false);
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </a>
                    </Tooltip>
                  ) : (
                    <a
                      href="/create-incident-log"
                      className="pull-right site-button btn-sm"
                    >
                      Create Incident Log
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="row">{printContent()}</div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default composedIncidentLogsContainer(IncidentLogMainComponent);